@if (testMode) {
  <div class="holder">
    <mat-checkbox [formControl]="otherBuildings" class="positive"
    >Andra boenden
    </mat-checkbox>
    <mat-checkbox [formControl]="coApplicant" class="positive">
      Medlåntagare
    </mat-checkbox>
    <mat-checkbox [formControl]="borgo" class="negative">Borgo
    </mat-checkbox>
    @if (type() !== 'APPLICATION') {
      <button (click)="setTest()" class="positive"
              matButton="outlined">Fyll i
      </button>
    }
    <button (click)="fillAll()" matButton="outlined">Allt</button>
  </div>
}